import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'
import { BodyCopy } from './BodyContentBlock.styles'

export const GridBlock = styled(GriddedContentBlock)`
  /* Naming Convenience */
  margin-top: 0;
`

export const Grid = styled.div`
  grid-column: 2 / 12;

  @media ${DEVICE.laptopS} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 32px 5.3%;
    margin-bottom: unset;
  }

  &[data-columns='--3-column'] {
    @media ${DEVICE.laptopS} {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const GridItem = styled.div`
  margin-bottom: 26px;

  @media ${DEVICE.laptopS} {
    margin-bottom: 0;
  }
`

export const Summary = styled(BodyCopy)`
  /* naming convenience */
  p {
    margin-bottom: 0;
  }
`

export const GridItemColumn = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 2rem;
    line-height: 1.35;
    color: var(--content-background-dark-blue);
    margin-bottom: 14px;

    @media ${DEVICE.laptopS} {
      font-size: 2.4rem;
      line-height: 1.375;
      margin-bottom: 12px;
    }
  }

  p {
    font-size: 1.4rem;
    line-height: 1.375;
    color: var(--content-background-dark-blue);

    @media ${DEVICE.laptopS} {
      font-size: 1.8rem;
      line-height: 1.388;
    }
  }

  a {
    p {
      color: var(--highlight-blue);
      font-size: 1.4rem;
      line-height: 1.375;
    }
  }

  ul {
    margin-top: 20px;
    padding-left: 20px;

    @media ${DEVICE.laptopS} {
      padding: 0px 0px 1rem;
    }
  }
`

export const Picture = styled.picture`
  border-radius: 5px;
  width: 100%;
  height: auto;

  img {
    margin-bottom: 20px;
  }
`

export const additionalCtaStyles = `
  @media ${DEVICE.tabletL} {
    margin-top: 8px;
  }
`
